import axios from '@/utils/axios';

//获取微信授权用户信息
export function WeChatInfo(url) {
    return axios({
        url: '/wechat/sign',
        method: 'get',
        params: { url },
    });
}

